import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNotify } from 'react-admin';
import { 
  Button, Dialog, DialogTitle, DialogContent, DialogActions, 
} from '@material-ui/core';
import { differenceWith, cloneDeep } from 'lodash-es';
import * as dateMath from 'date-arithmetic';
import { isPastWeek, fromToday, getYearMonthDate3 } from "../calendar";

import { UPDATE_PUBLISH, SET_CUSTOMER, selectCustomer, selectPublishedDates } from "./reducer";
import { reqPublish } from './api';
import { getApiWeekdays } from './functions';

const PublishDialog = ({ open, week, publish, onClose }) => {
  
  const notify = useNotify();
  const dispatch = useDispatch();

  // customerId
  const customer = useSelector(selectCustomer);

  // get dates to publish 
  let tmpDates = getApiWeekdays(week);
  const publisedDates = useSelector(state => selectPublishedDates(state, tmpDates));
  // if (isPastWeek(week, 0)) {
  if (isPastWeek(week)) {
    if (!publish) {
      // 지난 주는 publish 만 허용 
      // throw exception 
      console.log('it\'s past week')
    }
  }
  else {
    if (publish) {
      // diff 
      tmpDates = differenceWith(tmpDates, publisedDates, 
        (a, b) => dateMath.eq(a, b, 'day'));
    }
    else {
      tmpDates = fromToday(tmpDates);
    }
  }
  
  console.log(tmpDates)

  // loading state 
  const [ loading, setLoading ] = useState(false);

  const handlePublish = async () => {
    try {
      setLoading(true);

      const { data } = await reqPublish(customer.id, tmpDates, publish);
      // check result 
      if (data?.result !== true) {
        throw '서버에서 응답 실패를 반환했습니다';
      }

      // dispatch published 
      dispatch({
        type: UPDATE_PUBLISH,
        payload: {
          dates: tmpDates,
          publish
        }
      });

      dispatch({
        type: SET_CUSTOMER,
        payload: {
          customer: cloneDeep(customer),
        },
      });

      setLoading(false);
      onClose();
    } catch (err) {
      console.error(err);
      setLoading(false);
      notify(`퍼블리시 실패했습니다.\n오류:${err}`, 'error');
    }
  }

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      onClose={onClose}
      // TODO disable backdrop 
    >
      <DialogTitle
        id="alert-dialog-title"
      >
        {publish ? '배포하시겠습니까?' : '배포를 취소하시겠습니까?'}
      </DialogTitle>
      <DialogContent>
        {tmpDates.length > 0 && `${getYearMonthDate3(tmpDates[0])} - ${getYearMonthDate3(tmpDates[tmpDates.length - 1])}`}
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose}
          disabled={loading}
        >
          Cencel
        </Button>
        <Button 
          onClick={handlePublish}
          disabled={loading}
          color="primary"
          autoFocus
        >
          {publish ? 'Publish' : 'Cancel Published'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PublishDialog;